import { makeRequest } from 'utils/requestLogger';

export default (participationID, payload) =>
  makeRequest(
    'put',
    `/api/participations/${participationID}/add_feedback_for_student`,
    payload
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/addFeedbackForStudent.js